import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';
import { BlockHeight } from '../../../models/BlockSettings';

class BlockTextWithBackgroundData {
  title?: BlockComponentText;
  url?: BlockComponentImage;
  height?: BlockHeight;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTextWithBackgroundData {
  export function make(height: BlockHeight, title?: string, url?: string): BlockTextWithBackgroundData {
    return {
      height,
      title: title ? BlockComponentText.make(title) : undefined,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(height = BlockHeight.NORMAL, image = '', title = 'テキストテキストテキストテキストテキストテキストテキストテキストテキスト<br />テキストテキストテキストテキストテキストテキストテキストテキストテキスト<br />テキストテキストテキストテキストテキストテキストテキストテキストテキスト<br />テキストテキストテキストテキストテキストテキストテキストテキストテキスト'): BlockTextWithBackgroundData {
    return make(
      height,
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
      image,
    );
  }
}

export default BlockTextWithBackgroundData;
